import React, { useContext, useState } from "react";
import { Grid, TextareaAutosize } from "@material-ui/core";
import RecurrentPaymentContext from "../../../../../infrastructure/Contexts/components/data/RecurrentPaymentsWrapper/context";
import RecurrentPaymentActions from "../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import CobeeButton from "../../../CobeeButton";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import useStyles from "./styles";

export default function RejectRentingModal(): JSX.Element {
  const [reason, setReason] = useState<string>("");

  const { textArea, containerButton } = useStyles();
  const { recurrentPaymentDetail } = useContext(RecurrentPaymentContext);
  const { rejectRenting, rejectRentingIsLoading } = useContext(
    RecurrentPaymentActions
  );
  const { id, category } = recurrentPaymentDetail;

  return (
    <Grid>
      <TextareaAutosize
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        className={textArea}
        placeholder={t("common-messages.write-the-reason")}
      />
      <Grid container justifyContent="flex-end" className={containerButton}>
        <CobeeButton
          disabled={reason === ""}
          isLoading={rejectRentingIsLoading}
          onClick={() => {
            rejectRenting({
              requestId: id,
              rejectedReason: reason,
              category,
            });
          }}
        >
          {t("actions.reject-request")}
        </CobeeButton>
      </Grid>
    </Grid>
  );
}
